import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PrioSharePublishDto } from '../../../../../models/PrioShare';
import { apiPublishPrioShare } from '../../../api';

export function usePublishPrioShare() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: PrioSharePublishDto) => {
      return apiPublishPrioShare(dto);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['prioShares', variables.projectExtensionId],
      });
    },
  });
}
